import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { siteConfig } from '../../config/siteConfig';
import { getWhatsAppLink } from '../../lib/utils';

/**
 * Bouton WhatsApp flottant — affiché en bas à droite de l'écran
 * Avec animation pulse et tooltip
 */
export default function WhatsAppButton() {
    return (
        <motion.a
            href={getWhatsAppLink(siteConfig.contact.whatsapp, 'Bonjour ZIG Investment ! Je souhaite en savoir plus sur vos services.')}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 group"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1, duration: 0.3, type: 'spring' }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Contacter sur WhatsApp"
        >
            {/* Cercle animé en arrière-plan */}
            <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-25" />

            {/* Bouton principal */}
            <div className="relative w-14 h-14 rounded-full bg-green-500 flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow duration-300">
                <MessageCircle className="w-7 h-7 text-white fill-current" />
            </div>

            {/* Tooltip */}
            <div className="absolute bottom-full right-0 mb-3 px-4 py-2 bg-navy-900 text-white text-sm rounded-xl shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
                WhatsApp
                <div className="absolute bottom-0 right-6 w-2 h-2 bg-navy-900 rotate-45 translate-y-1" />
            </div>
        </motion.a>
    );
}
